(function(global) {
	'use strict';

    document.addEventListener('DOMContentLoaded', function() {
		ISCL.onLoaded([
			refNote,
			contentsListAccordion
		]);
	}, false);
	window.addEventListener('resize', function() {
		ISCL.onResize(function() {
			if (clac.acc !== undefined) clac.onResize();
		});
	}, false);


    /**
	 * recipeOpening(); KVアニメーション
	 -------------------------------------------------- */
	document.addEventListener('DOMContentLoaded', function() {
		recipeOpening();
	}, false);
	window.addEventListener('resize', function() {
		ISCL.onResize();
	}, false);
	
	function recipeOpening() {
		if (document.querySelector('.keyvisual') !== null) {
			setTimeout(rop.constructor, 60);
		}
	}
	const rop = {
		constructor: function() {
			const keyvisual = document.getElementsByClassName('keyvisual')[0];
			keyvisual.classList.add('is-anim');
			keyvisual.classList.add('is-active');
			keyvisual.addEventListener('transitionend', this.animEnd);
		},
		animEnd: function(e) {
			console.log(e);
		}
	};


    /**
	 * STORYページ KVアニメーション
	 -------------------------------------------------- */
	document.addEventListener('DOMContentLoaded', function() {
		storyOpening();
		ISCL.onLoaded([ ISCL.webFontLoader ]);
	}, false);
	window.addEventListener('resize', function() {
		ISCL.onResize();
	}, false);
	
	function storyOpening() {
		if (document.querySelector('.p-visual') !== null) {
			setTimeout(so.constructor, 60);
		}
	}
	const so = {
		constructor: function() {
			const visual = document.getElementsByClassName('p-visual')[0];
			visual.classList.add('is-anim');
			visual.classList.add('is-active');
			visual.addEventListener('transitionend', this.animEnd, { once: true });
		},
		animEnd: function(e) {
			console.log(e);
		}
	};


    /**
	 * HOMEスライドショー
	 -------------------------------------------------- */
	document.addEventListener('DOMContentLoaded', function() {
		ISCL.onLoaded([
			// topKeyvisual
		]);
	}, false);
	window.addEventListener('resize', function() {
		ISCL.onResize(null);
	}, false);
	
	function topKeyvisual() {
		if (document.querySelector('.keyvisual .o-slider') !== null) kv.constructor();
	}
	const kv = {
		constructor: function() {
			this.elm = document.querySelector('.keyvisual .o-slider');
			if (Flickity) this.setupSlider();
			// ISCL.setupYouTube();
		},
		setupSlider: function() {
			this.slider = new Flickity(kv.elm, {
				contain: true,
				wrapAround: true,
				lazyLoad: true,
				autoPlay: 6000,
				pauseAutoPlayOnHover: false,
				arrowShape: 'M100,50a50,50,0,1,0-50,50A50,50,0,0,0,100,50ZM40.833,50,64.787,67.413a3.873,3.873,0,0,1,.854,5.412,3.887,3.887,0,0,1-3.135,1.593,3.84,3.84,0,0,1-2.275-.74L27.657,50,60.232,26.321a3.873,3.873,0,0,1,4.555,6.266Z',
				on: { settle: kv.onSettle }
			});
		},
		onSettle: function(index) {
			if (Flickity.data(kv.elm).player.state !== 'playing') {
				kv.slider.playPlayer();	
			}
		}
	};
  　　topKeyvisual();


    　/**
	 * purchaseModalUi(); 購入ボタン
	 -------------------------------------------------- */
    function purchaseModalUi() {
	 	if (document.querySelector('.js-modalTrigger') !== null) mcu.constructor();
	 }
  
	 const mcu = {
	 	constructor: function() {
        const purchaseModalMulti = document.querySelector('.js-cmodal-multi'); 
        const purchaseBtns = document.querySelectorAll('.c-purbtn');
        const modalOverlay = document.querySelectorAll('.modal_overlay, .modal_close');

        const purSingleBtns = document.querySelectorAll('.c-purbtn-single');

       let purchaseModalSingle;
    
        purchaseBtns.forEach(purchaseBtn => {
            purchaseBtn.addEventListener('click', function() {
                if (purchaseModalMulti.getAttribute('aria-hidden') === 'true') {
                    document.body.classList.add('is-fixed');
                    purchaseModalMulti.classList.add('is-anim', 'is-active');
                    purchaseModalMulti.setAttribute('aria-hidden', 'false');
                    this.setAttribute('aria-expanded', 'true');
                }
            });
        });

         purSingleBtns.forEach(purSingleBtn => {
			purSingleBtn.addEventListener('click', function() {
				purchaseModalSingle = purSingleBtn.nextElementSibling;
				if (purchaseModalSingle.getAttribute('aria-hidden') === 'true') {
					document.body.classList.add('is-fixed');
					purchaseModalSingle.classList.add('is-anim', 'is-active');
					purchaseModalSingle.setAttribute('aria-hidden', 'false');
					this.setAttribute('aria-expanded', 'true');
				}
			});
		});

         modalOverlay.forEach(overlay => {
            overlay.addEventListener('click', function() {
                document.body.classList.remove('is-fixed');
                purchaseModalMulti.classList.remove('is-anim', 'is-active');
                purchaseModalMulti.setAttribute('aria-hidden', 'true');
              
                if (purchaseModalSingle) {
                  purchaseModalSingle.classList.remove('is-anim', 'is-active');
                  purchaseModalSingle.setAttribute('aria-hidden', 'true');
                }
              
                this.setAttribute('aria-expanded', 'false');
            });
        });
      }
    }
    purchaseModalUi();
  

	/**
	 * knowledgeページの引用リンク
	 -------------------------------------------------- */
	function refNote() {
		if (document.querySelector('[data-ref]') !== null) rn.constructor();
	}
	const rn = {
		refArray: {},
		constructor: function() {
			const ref = document.querySelectorAll('[data-ref]');
			const note = document.querySelectorAll('[data-note]');
			
			for (let i = 0, len = ref.length; i< len; i++) {
				this.refDatalize(ref[i], ref[i].dataset['ref']);
				ref[i].firstChild.addEventListener('click', this.onClick)
			}
			//console.log(this.refArray);
			for (let i = 0, len = note.length; i < len; i++) {
				this.createNoteLink(note[i], note[i].dataset['note']);
			}
		},
		refDatalize: function(elm, id) {
			if (this.refArray['cite_ref-' + id] === undefined) {
				this.refArray['cite_ref-' + id] = [];
			}
			this.refArray['cite_ref-' + id].push('note');
			elm.id = 'cite_ref-' + elm.dataset['ref'] + '_' + this.refArray['cite_ref-' + id].length;
			
			elm.removeAttribute('data-ref');
			elm.innerHTML = '<a href="#cite_note-' + id + '" class="anc">' + elm.innerHTML + '</a>';
		},
		createNoteLink: function(elm, id) {
			elm.innerHTML = '<span id="cite_note-' + id + '">' + elm.innerHTML + '</span>';
			elm.insertAdjacentHTML('afterbegin', '<sup><a href="#cite_ref-' + id + '_1" class="anc">^</a></sup>');
		},
		onClick: function(e) {
			const noteElm = document.getElementById(this.getAttribute('href').slice(1));
			const refAnchor = noteElm.parentNode.getElementsByClassName('anc')[0];
			refAnchor.href = '#' + this.parentNode.id;
		}
	};
  　　refNote();
  

    /**
	 * アコーディオンメニュー
	 -------------------------------------------------- */
	function contentsListAccordion() {
		if (document.querySelector('.js-accordion') !== null) clac.constructor();
	}
  
	const clac = {
		constructor: function() {
			this.acc = [];
			const elms = document.getElementsByClassName('js-accordion');
			for (let i = elms.length; i--;) {
				this.setup(i, elms[i]);
			}
			//console.log(this.acc);
		},
		onResize: function() {
			for (let i = this.acc.length; i--;) {
				this.acc[i].maxHeight = this.acc[i].content.firstElementChild.clientHeight;
				this.acc[i].minHeight = this.returnMinHeight(this.acc[i].items);
				if (!this.acc[i].isOpen) {
					this.acc[i].content.style.height = this.acc[i].minHeight + 'px';
				}
			}
		},
		returnMinHeight: function(items) {
			const itemLength = ISCL.isDesktop ? 3 : 2;
			let compare = [];
			for (let i = itemLength; i--;) {
				compare.push(items[i].clientHeight);
			}
			const maxHeight = Math.max.apply(null, compare);
			return maxHeight;
		},
		maxReduce: function(arr) {
			arr.reduce(function(a, b) {
				return Math.max(a, b);
			});
		},
		setup: function(i, elm) {
			if (elm.querySelectorAll('li:not(.comingsoon)').length <= 3) {
				elm.removeChild(elm.getElementsByClassName('acc_button')[0]);
				return;
			}
			this.acc[i] = {};
			const acc = this.acc[i];
			const button = elm.getElementsByClassName('acc_button')[0];
			
			acc.isOpen = 0;
			acc.content = elm.getElementsByClassName('acc_contents')[0];
			acc.items = acc.content.firstElementChild.children;
			acc.maxHeight = acc.content.firstElementChild.clientHeight;
			acc.minHeight = this.returnMinHeight(acc.items);
			
			acc.content.style.height = acc.minHeight + 'px';
			button.addEventListener('click', function(e) {
				!acc.isOpen ? clac.accOpen(acc) : clac.accClose(acc);
			});
		},
		accOpen: function(t) {
			t.isOpen = 1;
			t.content.parentNode.classList.add('is-anim');
			t.content.parentNode.classList.add('is-opened');
			t.content.style.height = t.maxHeight + 'px';
			t.content.addEventListener('transitionend', clac.openEnd);
		},
		openEnd: function() {
			this.parentNode.classList.remove('is-anim');
			this.removeAttribute('style');
			this.removeEventListener('transitionend', clac.openEnd);
		},
		accClose: function(t) {
			t.isOpen = 0;
			t.content.style.height = t.maxHeight + 'px';
			setTimeout(function() {
				t.content.parentNode.classList.add('is-anim');
				t.content.parentNode.classList.remove('is-opened');
				t.content.style.height = t.minHeight + 'px';
				t.content.addEventListener('transitionend', clac.closeEnd);
			}, 60);
		},
		closeEnd: function() {
			this.parentNode.classList.remove('is-anim');
			this.removeEventListener('transitionend', clac.closeEnd);
		}
	};
    contentsListAccordion();


  /**
	 * YouTube API
	 -------------------------------------------------- */
	function setupYouTube() {
		if (document.querySelector('.js-yt') !== null) yt.constructor();
	}
	ISCL.setupYouTube = setupYouTube;
	const yt = {
		constructor: function() {
			//console.log('-----> setupYouTube');
			this.firstElm = document.getElementsByClassName('js-yt')[0];
			this.elmTop = parseInt(this.firstElm.getBoundingClientRect().top + window.pageYOffset);
			window.addEventListener('scroll', this.onScroll, false);
		},
		onScroll: function() {
			if (window.pageYOffset + window.innerHeight > yt.elmTop) yt.ready();
			if (yt.elmTop !== parseInt(yt.firstElm.getBoundingClientRect().top + window.pageYOffset)) {
				yt.elmTop = parseInt(yt.firstElm.getBoundingClientRect().top + window.pageYOffset);
			}
		},
		ready: function() {
			window.removeEventListener('scroll', yt.onScroll, false);
			delete yt.elmTop;
			yt.player = {};
			yt.playerVars = { controls: 0, modestbranding: 1, enablejsapi: 1, playsinline: 1, rel: 0 };
			yt.loadAPI();
		},
		loadAPI: function() {
			let tag = document.createElement('script');
			tag.src = 'https://www.youtube.com/iframe_api';
			let firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
			global.onYouTubeIframeAPIReady = function() { yt.init(); }
		},
		init: function() {
			const ytElms = document.getElementsByClassName('js-yt');
			let id, ytid, w, h;
			for (let i = 0, len = ytElms.length; i < len; i++) {
				//console.dir(ytElms[i]);
				id = 'player-' + i;
				ytid = ytElms[i].dataset['ytid'];
				w = ytElms[i].getAttribute('width');
				h = ytElms[i].getAttribute('height');
				ytElms[i].setAttribute('id', id);
				yt.setup(id, ytid, w, h);
				this.setUI(ytElms[i].parentNode.parentNode, id);
			}
		},
		setUI: function(wrap, id) {
			//console.log(wrap);
			const poster = wrap.getElementsByClassName('poster')[0];
			poster.dataset['player'] = id;
			poster.addEventListener('click', this.onPlay);
		},
		setup: function(id, ytid, w, h) {
			this.player[id] = new YT.Player(id, {
				width: w, height: h, videoId: ytid,
				playerVars: this.playerVars,
				events: {
					'onReady': yt.onPlayerReady,
					'onStateChange': yt.onPlayerStateChange
				}
			});
		},
		onPlay: function() {
			if (yt.player === undefined) return;
			//console.log('onPlay');
			const player = yt.player[this.dataset['player']];
			if (player.getPlayerState() !== 1) {
				this.parentNode.classList.add('is-playing');
				player.playVideo();
			} else {
				player.pauseVideo();
			}
		},
		onPlayerReady: function(e) {
			//console.log('onPlayerReady', e);
		},
		onPlayerStateChange: function(e) {
			//console.log('onPlayerStateChange', e);
			if (e.data === 0 || e.data === 2) {
				e.target.getIframe().parentNode.parentNode.classList.remove('is-playing');
			}
		}
	};
  setupYouTube();


    /**
	 * ネスレ100のタブコンテンツ表示
	 -------------------------------------------------- */
	document.addEventListener('DOMContentLoaded', function() {
		ISCL.onLoaded([
			setupTabsUi,
		]);
	}, false);
	window.addEventListener('resize', function() {
        if (tab.tabsData !== undefined) tab.onResize();
		ISCL.onResize(function() {
			if (tab.tabsData !== undefined) tab.onResize();
		});
	}, false);

	function setupTabsUi() {
		if (document.querySelector('.o-tabs') !== null) {
			//console.log('-----> setupTabsUi');
			tab.constructor();
		}
	}
	const tab = {
		tabMode: ISCL.isDesktop,
		constructor: function() {
			this.tabsData = {};
			const tabs = document.getElementsByClassName('o-tabs');
			for (let i = tabs.length; i--;) {
				this.setup(tabs[i]);
			}
			if (ISCL.isDesktop) {
				this.resetToDesktop();
			} else {
				this.resetToMobile();
			}
			// console.log(this.tabsData);
		},
		setup: function(tabs) {
			const tabButton = tabs.getElementsByClassName('js-tabToggle');
			const tabContent = tabs.getElementsByClassName('tabs_content');
			let id, button, contents, cssstyle, paddingTop, paddingBtm, padding;
			for (let i = tabButton.length; i--;) {
				tabButton[i].addEventListener('click', this.onClick);
				id = tabButton[i].dataset.tab;
				button = tabButton[i].parentNode;
				contents = button.nextElementSibling;
				cssstyle = getComputedStyle(contents, null);
				paddingTop = cssstyle.getPropertyValue('padding-top');
				paddingBtm = cssstyle.getPropertyValue('padding-bottom');
				padding = parseInt(paddingTop) + parseInt(paddingBtm);
				
				let buttons = button.parentNode.getElementsByClassName('tabs_button');
				buttons = [].slice.call(buttons);
				
				this.tabsData[id] = {
					isDefault: buttons.indexOf(button) === 0,
					isOpened: tabButton[i].parentNode.className.indexOf('is-active') !== -1,
					elm: tabs,
					btn: button,
					contents: contents,
					padding: padding,
					contentsHeight: contents.firstElementChild.clientHeight + padding
				};
			}
			//console.log(this.tabsData);
			this.tabButton = tabButton;
			this.tabContent = tabContent;
		},
		resetToDesktop: function() {
			let t;
			for (let i in this.tabsData) {
				t = this.tabsData[i];
				t.contents.removeAttribute('style');
				if (!t.isDefault) {
					t.isOpened = false;
					t.btn.classList.remove('is-active');
					t.contents.classList.remove('is-active');
				} else {
					t.isOpened = true;
					t.btn.classList.add('is-active');
					t.contents.classList.add('is-active');
				}
			}
		},
		resetToMobile:  function() {
            let t;
			for (let i in this.tabsData) {
				t = this.tabsData[i];
				t.isOpened = false;
				t.btn.classList.remove('is-active');
				t.contents.classList.remove('is-active');
				t.contents.style.height = 0;
			}
		},
		onResize: function() {
			if (this.tabMode === ISCL.isDesktop) return;
			if (ISCL.isDesktop) {
				this.resetToDesktop();
			} else {
				this.resetToMobile();
			}
			this.tabMode = ISCL.isDesktop;
			
			for (let i in this.tabsData) {
				this.tabsData[i].contentsHeight = this.tabsData[i].contents.firstElementChild.clientHeight + this.tabsData[i].padding;
			}
		},
		onClick: function() {
			if (ISCL.isDesktop) {
				tab.desktopUi(this.dataset.tab);
			} else {
				tab.mobileUi(this.dataset.tab);
			}
		},
		desktopUi: function(id) {
			const t = this.tabsData[id];
			const actives = t.elm.getElementsByClassName('is-active');
			
			for (let i = actives.length; i--;) {
				actives[i].classList.add('is-anim');
				actives[i].classList.remove('is-active');
			}
			t.isOpened = true;
			t.btn.classList.add('is-anim');
			t.btn.classList.add('is-active');
			t.contents.classList.add('is-anim');
			t.contents.classList.add('is-active');
		},
		mobileUi: function(id) {
			const t = this.tabsData[id];
			const actives = t.elm.getElementsByClassName('is-active');
			
			if (t.isOpened) {
				t.isOpened = false;
				t.btn.classList.remove('is-active');
				t.contents.classList.remove('is-active');
				this.pullUp(t);
			} else {
				t.isOpened = true;
				t.btn.classList.add('is-active');
				t.contents.classList.add('is-active');
				this.pullDown(t);
			}
		},
		pullUp: function(t) {
			t.contents.classList.add('is-anim');
			t.contents.style.height = t.contentsHeight + 'px';
			setTimeout(function() {
				t.contents.style.height = 0;
			}, 60);
			t.contents.addEventListener('transitionend', this.pullEnd);
		},
		pullDown: function(t) {
			t.contents.classList.add('is-anim');
			t.contents.style.height = t.contentsHeight + 'px';
			t.contents.addEventListener('transitionend', this.pullEnd);
		},
		pullEnd: function(e) {
			if (e.propertyName === 'height') {
				const t = tab.tabsData[this.id];
				if (this.clientHeight > t.padding) {
					this.removeAttribute('style');
				}
				this.classList.remove('is-anim');
				this.removeEventListener('transitionend', tab.pullEnd);
			}
		}
	}
  　　setupTabsUi();
  
})((this || 0).self || global);